module.exports = __webpack_public_path__ + "archive.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/archive.png
// module id = 394
// module chunks = 0